var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        }
      }
    },
    [
      _c("div", { staticClass: "text_large" }, [
        _vm._v(
          _vm._s(_vm.i18n.trd_create_sell_order({ value: _vm.assets.base }))
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "md-layout md-gutter" }, [
        _c(
          "div",
          { staticClass: "md-layout-item md-small-size-100" },
          [
            _c("input-field", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "md-layout-item field__number",
              attrs: {
                label: _vm.i18n.trd_total_sell({ asset: _vm.assets.base }),
                name: "order-buy-amount",
                type: "number",
                step: "0.01",
                errorMessage:
                  _vm.allowToValidAmount &&
                  _vm.lessThanMinimumAmount &&
                  _vm.currentField === "amount"
                    ? _vm.i18n.trd_validate_minimal_amount({
                        value: _vm.getMinimumAmount
                      })
                    : ""
              },
              nativeOn: {
                focusout: function($event) {
                  return _vm.roundAmount(_vm.assets.base)
                }
              },
              model: {
                value: _vm.form.amount,
                callback: function($$v) {
                  _vm.$set(
                    _vm.form,
                    "amount",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "form.amount"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "md-layout md-gutter" }, [
        _c(
          "div",
          { staticClass: "md-layout-item md-small-size-100" },
          [
            _c("input-field", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "md-layout-item field__number",
              attrs: {
                label: _vm.i18n.trd_price_per({ asset: _vm.assets.base }),
                name: "order-buy-price",
                type: "number",
                step: "0.01",
                errorMessage:
                  _vm.lessThanMinimumPrice &&
                  _vm.allowToValidPrice &&
                  _vm.currentField === "price"
                    ? _vm.i18n.trd_validate_minimal_price({
                        value: _vm.getMinimumPrice
                      })
                    : ""
              },
              nativeOn: {
                focusout: function($event) {
                  return _vm.roundPrice(_vm.assets.base)
                }
              },
              model: {
                value: _vm.form.price,
                callback: function($$v) {
                  _vm.$set(
                    _vm.form,
                    "price",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "form.price"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "md-layout md-gutter" }, [
        _c(
          "div",
          { staticClass: "md-layout-item md-small-size-100" },
          [
            _c("input-field", {
              staticClass: "md-layout-item",
              attrs: {
                value: _vm.roundCurrency(
                  _vm.form.quoteAmount,
                  _vm.assets.quote
                ),
                label: _vm.i18n.trd_will_receive({ value: _vm.assets.quote }),
                name: "order-buy-total",
                disabled: true
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-wrap" },
        [
          _c(
            "md-button",
            {
              staticClass: "btn md-primary",
              attrs: {
                type: "submit",
                disabled:
                  _vm.isPending ||
                  _vm.lessThanMinimumAmount ||
                  _vm.lessThanMinimumPrice
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.i18n.trd_order_sell()) + "\n    ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28db46d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28db46d0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/trade/index/components/tradeOrders/TradeOrders.SellOrder.vue
// module id = uvBV
// module chunks = 1